import React, { ReactElement } from 'react';
import { JobsiteTabProps } from 'containers/jobsite/types';
import {
  JobsiteSchedules,
  JobsiteSchedulesNavigation,
  JobsiteSchedulesProvider,
} from './components';

export function JobsiteSchedulesTabContainer(
  props: JobsiteTabProps,
): ReactElement {
  return (
    <JobsiteSchedulesProvider {...props}>
      <div className="odin-flex odin-flex-col odin-gap-6">
        <JobsiteSchedulesNavigation />
        <JobsiteSchedules />
      </div>
    </JobsiteSchedulesProvider>
  );
}
